module.exports = __webpack_public_path__ + "static/media/instanceVPS.d3913bf0.PNG";